import { Injectable, inject } from '@angular/core';
import { forkJoin, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  DictionariesListModel,
  DictionariesService,
  GroupedAutocompleteOptions,
} from '@eagle/shared';
import { Params } from '@angular/router';

import { VacanciesApiService } from './vacancies-api.service';
import { VacancyModel, ListVacancyPayload, VacancyAllData } from '../models';

@Injectable({
  providedIn: 'root',
})
export class VacanciesDataService {
  private vacanciesApiService = inject(VacanciesApiService);
  private dictionariesService = inject(DictionariesService);

  getData(entityId: string, params: Params = null): Observable<VacancyAllData> {
    const vacancy$: Observable<VacancyModel> = entityId
      ? this.vacanciesApiService.get(entityId)
      : of(null);
    const vacancies$: Observable<ListVacancyPayload> = params
      ? this.vacanciesApiService.getAll(params)
      : of(null);

    const dictionariesList = [];
    const dictionaries$: Observable<DictionariesListModel> =
      this.dictionariesService.getDictionaries(dictionariesList);

    return forkJoin([vacancy$, vacancies$, dictionaries$]).pipe(
      map(([vacancy, vacancies, { dictionaries }]) => ({
        vacancy,
        vacancies,
        dictionaries,
      }))
    );
  }

  getListData(params?: Params): Observable<Partial<VacancyAllData>> {
    const vacancies$: Observable<ListVacancyPayload> = params
      ? this.vacanciesApiService.getAll(params)
      : of(null);

    return forkJoin([vacancies$]).pipe(
      map(([vacancies]: [ListVacancyPayload]) => ({
        vacancies,
      }))
    );
  }

  getSuggestionsList(term: string): Observable<GroupedAutocompleteOptions[]> {
    return this.vacanciesApiService.getSuggestions(term);
  }
}
